import { ReactElement } from "react";
import GuidedTour from "../GuidedTour";
import { StepType } from "@reactour/tour";

export const CreateCampaignSteps: StepType[] = [
  {
    selector: ".CampaignForm .campaign-name",
    position: "right",
    content: (
      <GuidedTour
        title="Fill out information for the campaign"
        content="To attract the right talent and ensure a successful recruitment process, please enter your information or take our example. Firstly, enter a clear and engaging Campaign name that capture the essence of the campaign. Keep it concise and memorable, such as  NextGen Talent Search."
      />
    ),
  },
  {
    selector: ".CampaignForm .campaign-position",
    position: "right",
    content: (
      <GuidedTour
        title="Fill out information for the campaign"
        content="Next, enter the specific Position that clearly define the role and responsibilities. Keep it precise and follow industry-standard terminology, such as Software Engineer."
      />
    ),
  },
  {
    selector: ".CampaignForm .campaign-experience",
    position: "right",
    content: (
      <GuidedTour
        title="Fill out information for the campaign"
        content="Select the appropriate Experience level that best matches the qualifications required for the position. This helps candidates understand if they meet the expectations for the role."
      />
    ),
  },
  {
    selector: ".CampaignForm .campaign-budget",
    position: "right",
    content: (
      <GuidedTour
        title="Fill out information for the campaign"
        content="Specify the budget allocated for the campaign by sliding the Circle or enter 500000 to set the Budget to 500.000 vnd (approximate 300 Hepp.coins)."
      />
    ),
  },
  {
    selector: ".CampaignForm .campaign-date",
    position: "right",
    content: (
      <GuidedTour
        title="Fill out information for the campaign"
        content="Select the timeframe for the recruitment efforts. Clear dates helps manage candidate expectations and ensures a smooth recruitment process. Set the Start date and End date to 01/01/2025 and 02/04/2025."
      />
    ),
  },
  {
    selector: ".CampaignForm .campaign-duration",
    position: "right",
    content: (
      <GuidedTour
        title="Fill out information for the campaign"
        content="The Duration is generated automatically based on the campaign’s Start date and End date. If the duration is changed, End date will be changed respectively."
      />
    ),
  },
  {
    selector: ".Heppai-Gantt",
    position: "right",
    content: (
      <GuidedTour
        title="Fill out information for the campaign"
        content="Besides, you can adjust these dates as needed to fit specific requirements easily by dragging."
      />
    ),
  },
  {
    selector: ".create-campaign-btn",
    position: "right",
    content: (
      <GuidedTour
        title="Fill out information for the campaign"
        content="Click here."
      />
    ),
  },
  {
    selector: ".ConfirmModal .confirm-btn",
    position: "right",
    content: (
      <GuidedTour
        title="Confirm"
        content="Creating a campaign will cost you 30 Hepp.coins and this action cannot be undone. You have received 50 coins when getting started the guided tour. Let’s pay for your first campaign with HEPPAI by clicking Confirm."
      />
    ),
  },
];
